// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `



.styles_container__T5HfY{
  display: flex;
  flex-wrap: wrap;
  row-gap: 31px;
  margin-top: 180px;
  justify-content: space-between;
  width: var(--container-width-md);
  max-width: 1512px;
  margin-inline: auto ;
}

.styles_information__voLrX{
  max-width: 848px;
  display: flex;
  flex-direction: column;
  row-gap: 31px;
  margin: auto;
}

.styles_image__h7mOL {
  margin: auto;
}
.styles_image__h7mOL > img{
  padding-top: 32px;
  width: 404px;
  height: 269px;
  
}

.styles_title__UpyJC > h2  {
  font-style: black;
  line-height: 100%;
  align-items: Center;
  vertical-align: center;
  text-align: justify;
  color: var(--color-secondary-black);
  font-style: var(--color-secondary-black);
  margin: auto;
  font-size: 50px;
}

.styles_information__voLrX > p{
  font-style: normal;
  text-align: justify;
  font-weight: 420;
  font-size: 30px;
  line-height: 43px;
}

.styles_button__7okuZ{
  width: 164px;
  height: 40px;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 500;
  font-family: 'Brandon Grotesque';
  cursor: pointer;
  background: linear-gradient(90deg, var(--color-primary) 0%, var(--color-secundary) 100%);
  color: var(--color-primary-white);
}

.styles_containerButton__mDm3o{
  display: flex;
  justify-content: space-around;
}

/*medium and small sreens */
@media screen and (min-width: 1281px ){
  .styles_information__voLrX{
    max-width: clamp(748px,56vw,848px);
  
  }
}

@media screen and (max-width: 1280px ){
  .styles_container__T5HfY{
    margin-top: 120px;
  }
  .styles_containerButton__mDm3o{
    flex-wrap: wrap;
    row-gap: 10px;
    column-gap: 10px;
  }
  .styles_information__voLrX{
    max-width: clamp(642px,56vw,748px);
    display: flex;
    flex-direction: column;
    row-gap: 31px;
    margin: auto;
  }
  .styles_title__UpyJC > h2  {
    font-size: clamp(45px,10vw,50px);
  }
}

@media screen and (max-width: 820px ){
  .styles_container__T5HfY{
    margin-top: 64px;
  }
  .styles_title__UpyJC > h2  {
    font-size: clamp(28px,6vw,45px);
  }
  
  .styles_information__voLrX > p{
   
    font-size: clamp(20px,3vw,23px);
    line-height: 25px;
  
  }
  .styles_image__h7mOL > img{
    padding-top: 32px;
    width: clamp(265px,2vw,404px);
    height: 269px;
    
  }
}`, "",{"version":3,"sources":["webpack://./src/components/HeroBanner/styles.module.css"],"names":[],"mappings":";;;;AAIA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,gCAAgC;EAChC,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;;AAEf;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,mCAAmC;EACnC,wCAAwC;EACxC,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,wFAAwF;EACxF,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA,2BAA2B;AAC3B;EACE;IACE,kCAAkC;;EAEpC;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,kCAAkC;IAClC,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,YAAY;EACd;EACA;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,+BAA+B;EACjC;;EAEA;;IAEE,+BAA+B;IAC/B,iBAAiB;;EAEnB;EACA;IACE,iBAAiB;IACjB,6BAA6B;IAC7B,aAAa;;EAEf;AACF","sourcesContent":["\r\n\r\n\r\n\r\n.container{\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  row-gap: 31px;\r\n  margin-top: 180px;\r\n  justify-content: space-between;\r\n  width: var(--container-width-md);\r\n  max-width: 1512px;\r\n  margin-inline: auto ;\r\n}\r\n\r\n.information{\r\n  max-width: 848px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  row-gap: 31px;\r\n  margin: auto;\r\n}\r\n\r\n.image {\r\n  margin: auto;\r\n}\r\n.image > img{\r\n  padding-top: 32px;\r\n  width: 404px;\r\n  height: 269px;\r\n  \r\n}\r\n\r\n.title > h2  {\r\n  font-style: black;\r\n  line-height: 100%;\r\n  align-items: Center;\r\n  vertical-align: center;\r\n  text-align: justify;\r\n  color: var(--color-secondary-black);\r\n  font-style: var(--color-secondary-black);\r\n  margin: auto;\r\n  font-size: 50px;\r\n}\r\n\r\n.information > p{\r\n  font-style: normal;\r\n  text-align: justify;\r\n  font-weight: 420;\r\n  font-size: 30px;\r\n  line-height: 43px;\r\n}\r\n\r\n.button{\r\n  width: 164px;\r\n  height: 40px;\r\n  border-radius: 8px;\r\n  font-size: 18px;\r\n  font-weight: 500;\r\n  font-family: 'Brandon Grotesque';\r\n  cursor: pointer;\r\n  background: linear-gradient(90deg, var(--color-primary) 0%, var(--color-secundary) 100%);\r\n  color: var(--color-primary-white);\r\n}\r\n\r\n.containerButton{\r\n  display: flex;\r\n  justify-content: space-around;\r\n}\r\n\r\n/*medium and small sreens */\r\n@media screen and (min-width: 1281px ){\r\n  .information{\r\n    max-width: clamp(748px,56vw,848px);\r\n  \r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1280px ){\r\n  .container{\r\n    margin-top: 120px;\r\n  }\r\n  .containerButton{\r\n    flex-wrap: wrap;\r\n    row-gap: 10px;\r\n    column-gap: 10px;\r\n  }\r\n  .information{\r\n    max-width: clamp(642px,56vw,748px);\r\n    display: flex;\r\n    flex-direction: column;\r\n    row-gap: 31px;\r\n    margin: auto;\r\n  }\r\n  .title > h2  {\r\n    font-size: clamp(45px,10vw,50px);\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 820px ){\r\n  .container{\r\n    margin-top: 64px;\r\n  }\r\n  .title > h2  {\r\n    font-size: clamp(28px,6vw,45px);\r\n  }\r\n  \r\n  .information > p{\r\n   \r\n    font-size: clamp(20px,3vw,23px);\r\n    line-height: 25px;\r\n  \r\n  }\r\n  .image > img{\r\n    padding-top: 32px;\r\n    width: clamp(265px,2vw,404px);\r\n    height: 269px;\r\n    \r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__T5HfY`,
	"information": `styles_information__voLrX`,
	"image": `styles_image__h7mOL`,
	"title": `styles_title__UpyJC`,
	"button": `styles_button__7okuZ`,
	"containerButton": `styles_containerButton__mDm3o`
};
export default ___CSS_LOADER_EXPORT___;
